import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from '../../services/commen/commen.services';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-view-edit-user-image-box',
  templateUrl: './view-edit-user-image-box.component.html',
  styleUrls: ['./view-edit-user-image-box.component.scss']
})
export class ViewEditUserImageBoxComponent implements OnInit {
  @Output() outputKeyword: EventEmitter<any> = new EventEmitter();
  @Output() onDelete: EventEmitter<any> = new EventEmitter();
  @Input() imgUrl: any;
  @ViewChild('fileInput') fileInput: ElementRef;
  actionList: any[];
  constructor(private toastr: ToastrService, private commonService: CommonService, private translate: TranslateService,) { }
  ngOnInit() {
    this.actionList = [
      {
        label: 'Delete', icon: 'pi pi-trash',
        command: () => {
          this.onDeleteFn();
        }
      },
      {
        label: 'Upload', icon: 'pi pi-upload',
        command: () => {
          this.fileInput.nativeElement.click();
        }
      },
    ]
  }
  onFileSelected(event: any): void {
    const files = (event.target as HTMLInputElement).files;

    if (!files || files.length === 0) {
      this.toastr.error(this.translate.instant("FileUpload.Selectfileupload"), "error");
      return;
    }
    if (files.length > 1) {
      this.toastr.error(this.translate.instant("FileUpload.Selectsinglefile"), "error");
      return
    }
    for (const file of Array.from(files)) {
      if (this.commonService.isValidFileType(file) && this.commonService.isFileSizeExceeded(file) && this.commonService.isValidFileName(file)) {
        this.outputKeyword.emit(file);
        this.createUrlforDoc(file);
      }
    }
  }

  private createUrlforDoc(file: File): Promise<string> {
    return new Promise<string>((resolve) => {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        resolve(e.target.result);
        this.imgUrl = e.target.result;
      };
      reader.readAsDataURL(file);
    });
  }

  onDeleteFn() {
    this.imgUrl = null;
    this.onDelete.emit();
  }
}
